module.exports = __webpack_public_path__ + "img/login-art-4.cf05a96.jpg";